import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory } from 'react-router-dom';
import ConfigContext from '../../contexts/ConfigContext';

import TruckTeaseBadges from './TruckTeaseBadges';

import styles from './TruckTease.module.postcss';

function TruckTease({ truck, showMenuLink = false, noLazy = false }) {
  const { imageBase } = useContext(ConfigContext);
  const history = useHistory();

  const categories = truck.food_categories_string;
  const truckUrl = `/food-trucks/${truck.id}`;
  let image = '/static/images/truck-placeholder.png';
  if (truck.featured_photo) {
    image = `${imageBase}/${truck.featured_photo}`;
  }

  return (
    <div className={styles.TruckTease}>
      <Link to={truckUrl} target='_blank' rel='noopener noreferrer'>
        <div className={styles.TruckTease_image}>
          <img
            src={image}
            alt={truck.name}
            loading={noLazy ? 'eager' : 'lazy'}
            fetchpriority={noLazy ? 'high' : 'low'}
          />

          { truck.logo &&
            <div className={styles.TruckTease_logo}>
              <img
                src={`${imageBase}/${truck.logo}`}
                alt={`${truck.name} logo`}
                loading={noLazy ? 'eager' : 'lazy'}
                fetchpriority={noLazy ? 'high' : 'low'}
              />
            </div>
          }
        </div>

        <div className={styles.TruckTease_info}>
          <div>
            <div className={styles.TruckTease_name}>{truck.name}</div>
            <div className={styles.TruckTease_category}>{categories}</div>
            <TruckTeaseBadges vehicleType={truck.vehicle_type} establishedYear={truck.established_year} />
          </div>
        </div>
      </Link>

      { showMenuLink &&
        <div className={styles.TruckTease_menuLink}>
          <Link
            to={truckUrl + '#menu'}
            className='Button Button--outlined'
          >
            View Menu
          </Link>
        </div>
      }
    </div>
  );
}

TruckTease.propTypes = {
  truck: PropTypes.object.isRequired,
};

export default TruckTease;
